import { render, staticRenderFns } from "./EmployeeMassCreditPolicyPage.vue?vue&type=template&id=15849d64&"
import script from "./EmployeeMassCreditPolicyPage.vue?vue&type=script&lang=js&"
export * from "./EmployeeMassCreditPolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports